function buildDealerObject() {
  let mmdId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let sponsor = arguments.length > 1 ? arguments[1] : undefined;
  return {
    sponsor,
    id: Number(mmdId)
  };
}
export { buildDealerObject as default };
